import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { userStamp } from '../../../../utils/dateFunctions';
import { pushModal } from '../../../../actions/modals';
import { ATTACHMENT_MODAL } from '../../../../actions/types';
import { updateAttachment } from '../../../../actions/apiAttachments';
import getMediaType, { getFileExtension, isImageFile, isVideoFile } from '../../../../utils/mediaTypes';
import AttachmentVideo from '../../../../components/AttachmentVideo';
import { dollarTabWorkItemSelectOptions, workItemSelectOptions, selectedWorkItemValue, workItemPatchFromValue } from './fileAttachmentWorkItems';

class FileAttachmentSingle extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			addDepartmentPropertyError: '',
			imageVisible: false,
			invalidFileType: false,
			pendingWorkItemValue: null,
			workItemSaving: false,
		};
		this.onClick = this.onClick.bind(this);
		this.getfiletype = this.getfiletype.bind(this);
		this.triggerModal = this.triggerModal.bind(this);
		this.showImage = this.showImage.bind(this);
		this.onPreview = this.onPreview.bind(this);
		this.triggerInvalidFileMessage = this.triggerInvalidFileMessage.bind(this);
		this.saveAsBlob = this.saveAsBlob.bind(this);
		this.downloadFile = this.downloadFile.bind(this);
		this.onWorkItemChange = this.onWorkItemChange.bind(this);
	}

	getfiletype() {
		const file = this.props.attachment.fileid;
		const filetype = getFileExtension(file);
		let icon = '';
		if (filetype === 'pdf') {
			icon = 'fa-file-pdf';
		} else if (filetype === 'csv' || filetype === 'xls' || filetype === 'xlsx') {
			icon = 'fa-file-excel';
		} else if (filetype === 'jpg' || filetype === 'jpeg' || filetype === 'png' || filetype === 'gif') {
			icon = 'fa-image';
		} else if (isVideoFile(file)) {
			icon = 'fa-file-video';
		} else if (filetype === 'doc' || filetype === 'docx') {
			icon = 'fa-file-word'
		} else if (filetype === 'txt') {
			icon = 'fa-file-lines';
		} else {
			icon = 'fa-file';
		}
		return icon;
	}

	onClick() {
		this.props.delete(this.props.attachment.id);
	}

	onWorkItemChange(e) {
		const nextValue = e.target.value;
		const vehicle_id = this.props.vehicle_id || this.props.active_vehicle.id;
		this.setState({ pendingWorkItemValue: nextValue, workItemSaving: true });
		Promise.resolve(this.props.updateAttachment(this.props.attachment.id, {
			vehicle_id,
			...workItemPatchFromValue(nextValue),
		}, 'updateAttachmentError')).then(() => {
			this.setState({ pendingWorkItemValue: null, workItemSaving: false });
		}).catch(() => {
			this.setState({ pendingWorkItemValue: null, workItemSaving: false });
		});
	}

	onPreview() {
		const fileType = this.getfiletype();
		if (fileType === 'fa-image') this.showImage();
		else if (fileType === 'fa-file-pdf') this.triggerModal();
		else this.triggerInvalidFileMessage();
	}

	triggerModal = () => this.props.pushModal({
		type: ATTACHMENT_MODAL,
		props: {
			title: this.props.attachment.fileid,
			attachment: this.props.attachment,
		},
	});

	showImage = () => {
		this.setState({ imageVisible: !this.state.imageVisible });
	};

	triggerInvalidFileMessage = () => {
		this.setState({ invalidFileType: !this.state.invalidFileType });
	};

	saveAsBlob = async fileUrl => {
		const url = fileUrl
		const response = await fetch(url);
		const blob = await response.blob();
		return blob;
	};

	downloadFile = async () => {
		const blob = await this.saveAsBlob(this.props.attachment.location);
		const mediaType = getMediaType(this.props.attachment.fileid);
		const downloadBlob = new Blob([blob], { type: mediaType });
		const data = window.URL.createObjectURL(downloadBlob);
		const link = document.createElement('a');
		link.href = data;
		link.setAttribute('download', this.props.attachment.fileid.split('.').shift());
		document.body.appendChild(link);
		link.click();
		setTimeout(() => {
			document.body.removeChild(link);
			window.URL.revokeObjectURL(data);
		}, 100);
	};

	renderThumbnail() {
		const { attachment } = this.props;
		const thumbStyle = {
			width: 56,
			height: 56,
			borderRadius: 4,
			flexShrink: 0,
			objectFit: 'cover',
		};
		if (isImageFile(attachment.fileid)) {
			return (
				<img
					src={attachment.location}
					alt={attachment.fileid || ''}
					onClick={this.showImage}
					style={{ ...thumbStyle, cursor: 'pointer' }}
				/>
			);
		}
		return (
			<div
				className="d-flex align-items-center justify-content-center bg-light"
				style={thumbStyle}
				aria-hidden="true"
			>
				<i className={`fas ${this.getfiletype()}`} />
			</div>
		);
	}

	renderWorkItemSelect() {
		const vehicle = this.props.active_vehicle || {};
		const options = dollarTabWorkItemSelectOptions({
			allTabs: this.props.all_tabs,
			currentDealership: this.props.current_dealership,
			mpiWorkItems: [vehicle.mpi_work_items, this.props.mpi_work_items],
			appraisals: [vehicle.appraisals, this.props.appraisals],
			workItems: [vehicle.work_items, this.props.work_items],
			vehicleId: this.props.vehicle_id,
		});
		const value = selectedWorkItemValue(this.props.attachment);
		const displayValue = this.state.pendingWorkItemValue != null
			? this.state.pendingWorkItemValue
			: value;
		const missing = displayValue && !options.some(opt => opt.value === displayValue);
		// If linked to an MPI/legacy item not on the $ list, still resolve a readable label.
		const allOptions = missing ? workItemSelectOptions({
			mpiWorkItems: [vehicle.mpi_work_items, this.props.mpi_work_items],
			appraisals: [vehicle.appraisals, this.props.appraisals],
			workItems: [vehicle.work_items, this.props.work_items],
			vehicleId: this.props.vehicle_id,
		}) : options;
		const missingLabel = missing
			? ((allOptions.find(opt => opt.value === displayValue) || {}).label || 'Assigned item (unavailable)')
			: '';
		return (
			<label className="d-flex align-items-center mb-0 mt-2">
				<span className="small text-nowrap space-right-2">Work Item</span>
				<select
					className="form-select form-select-sm"
					aria-label="Work Item"
					value={displayValue}
					onChange={this.onWorkItemChange}
					disabled={this.state.workItemSaving}
					style={{ minWidth: 160, maxWidth: 240 }}
				>
					<option value="">None</option>
					{missing && (
						<option value={displayValue}>{missingLabel}</option>
					)}
					{options.map(opt => (
						<option key={opt.value} value={opt.value}>{opt.label}</option>
					))}
				</select>
			</label>
		);
	}

	render() {
		const createdDate = userStamp(this.props.attachment.created_at);
		const fileType = this.getfiletype();
		let imagePreview = '';
		if (fileType === 'fa-image') {
			imagePreview = (
			<div className="container">
				<img src={this.props.attachment.location} className="img-fluid" alt="Attachment Preview" style={{maxWidth: "500px"}} />
			</div>);
		}
		let imagePreviewText = this.state.imageVisible ? 'Hide Image' : 'Show Image';
		let previewMessage = "Unable to preview this file type.";
		const body = (
			<div className="flex-grow-1" style={{ minWidth: 0 }}>
				<div className="d-flex justify-content-between align-items-start flex-wrap">
					<h5 className="display-10 mb-0">{this.props.attachment.fileid}</h5>
					<span className="d-flex align-items-center flex-wrap">
						{fileType !== 'fa-file-video' && (
							<button type="button" onClick={this.onPreview} className="btn btn-sm btn-dark space-right-2">
								{fileType === 'fa-image' ? imagePreviewText : 'Preview'} <i className={`fas ${fileType}`} />
							</button>
						)}
						<button onClick={this.downloadFile} className="btn btn-sm btn-info text-light">
							Download <i className={'fas fa-cloud-download'} style={{color: "white"}} />
						</button>
						<button onClick={this.onClick} className="btn btn-sm btn-danger float-right space-left-2">
							Delete <i className={'fas fa-trash'} />
						</button>
					</span>
				</div>
				{this.props.showWorkItemSelect ? this.renderWorkItemSelect() : null}
				<small className="d-flex justify-content-end mt-2">Uploaded {this.props.attachment.user_name ? `by: ${this.props.attachment.user_name.split('@')[0]} ` : ''}on: {createdDate}</small>
				{fileType === 'fa-file-video' && (
					<div className="container mt-2">
						<AttachmentVideo src={this.props.attachment.location} filename={this.props.attachment.fileid} />
					</div>
				)}
				{this.state.imageVisible ? imagePreview : ''}
				{this.state.invalidFileType ? <div className="text-center">{previewMessage}</div> : ''}
			</div>
		);

		return (
			<li className="list-group-item">
				{this.props.showThumbnail ? (
					<div className="d-flex align-items-start">
						<div className="space-right-2">{this.renderThumbnail()}</div>
						{body}
					</div>
				) : body}
			</li>
		);
	}
}

const mappedActions = {
	pushModal,
	updateAttachment,
};

function mapStateToProps(state) {
	return {
		current_dealership: state.settings_dealerships.current_dealership,
		active_vehicle: state.settings_refresh.active_vehicle,
		mpi_work_items: state.settings_refresh.mpi_work_items,
		appraisals: state.settings_refresh.appraisals,
		work_items: state.settings_refresh.work_items,
		all_tabs: state.settings_site.all_tabs,
	};
}

export default connect(mapStateToProps, mappedActions)(FileAttachmentSingle);
